import { ParsedPath } from '@/utils/svgPathParser';
import { LINE_STYLES, COLORS } from '../constants';

type VisibleEdgesProps = {
  paths: ParsedPath[];
};

function isHiddenEdge(p: ParsedPath): boolean {
  return !!p.strokeDasharray && p.strokeDasharray !== 'none';
}

export function VisibleEdges({ paths }: VisibleEdgesProps) {
  const visiblePaths = paths.filter((p) => !isHiddenEdge(p));

  return (
    <g className="visible-edges">
      {visiblePaths.map((p, i) => (
        <path
          key={i}
          d={p.d}
          stroke={p.stroke ?? COLORS.line}
          strokeWidth={p.strokeWidth ?? LINE_STYLES.visible.strokeWidth}
          fill={p.fill ?? 'none'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </g>
  );
}

export function HiddenEdges({ paths }: VisibleEdgesProps) {
  const hiddenPaths = paths.filter(isHiddenEdge);

  if (hiddenPaths.length === 0) return null;

  return (
    <g className="hidden-edges">
      {hiddenPaths.map((p, i) => (
        <path
          key={i}
          d={p.d}
          stroke={p.stroke ?? COLORS.line}
          strokeWidth={p.strokeWidth ?? LINE_STYLES.hidden.strokeWidth}
          strokeDasharray={LINE_STYLES.hidden.dashArray}
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          opacity={0.5}
        />
      ))}
    </g>
  );
}
